import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Pressable, TextInput, Keyboard, View } from 'react-native';
import { checkIsPlatform, getTestId } from '../../../../utils';
import { Typography } from '../../../typography';
import { getInputInitialStyles } from '../../InputStyles';
export var OtpFields = props => {
  var otpFieldLength = props.otpFieldLength,
    _props$maskedLength = props.maskedLength,
    maskedLength = _props$maskedLength === void 0 ? 0 : _props$maskedLength,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OtpFields' : _props$testID,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _onFocus = props.onFocus,
    readOnly = props.readOnly,
    onChangeText = props.onChangeText,
    _onBlur = props.onBlur;
  var inputRef = useRef(null);
  var _useState = useState(false),
    isKeyboardVisible = _useState[0],
    setIsKeyboardVisible = _useState[1];
  var _useState2 = useState(0),
    activeFieldIndex = _useState2[0],
    setActiveFieldIndex = _useState2[1];
  var _useState3 = useState(''),
    value = _useState3[0],
    setValue = _useState3[1];
  var inputStyles = getInputInitialStyles(props);
  var disabledTextInput = isDisabled || readOnly;
  useEffect(() => {
    var keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', () => {
      setIsKeyboardVisible(true);
    });
    var keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
      setIsKeyboardVisible(false);
    });
    return () => {
      keyboardDidShowListener.remove();
      keyboardDidHideListener.remove();
    };
  }, []);
  var otpFieldMarginStyle = useCallback(index => ({
    marginEnd: otpFieldLength - 1 === index ? 0 : 8.6
  }), [otpFieldLength]);
  var onChangeTextHandler = text => {
    text = text.replace(/[^+\d]/g, '');
    setValue(text);
    setActiveFieldIndex(text.length);
    onChangeText(text);
  };
  var otpFieldsArray = new Array(otpFieldLength).fill('');
  return _jsxs(Pressable, Object.assign({
    style: inputStyles.otpContainer,
    onPress: () => {
      var _a, _b, _c, _d, _f, _g, _h;
      if (!((_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.isFocused) === null || _b === void 0 ? void 0 : _b.call(_a))) {
        (_d = (_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.call(_c);
      }
      if (!isKeyboardVisible) {
        (_f = inputRef.current) === null || _f === void 0 ? void 0 : _f.blur();
        (_h = (_g = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _g === void 0 ? void 0 : _g.focus) === null || _h === void 0 ? void 0 : _h.call(_g);
      }
    }
  }, {
    children: [_jsx(TextInput, Object.assign({
      style: inputStyles.textInputOtpContainer,
      keyboardType: "numeric",
      autoFocus: false,
      maxLength: otpFieldLength,
      onChangeText: onChangeTextHandler,
      value: value
    }, !readOnly && {
      onFocus: event => {
        _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(event);
      }
    }, {
      onBlur: event => {
        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(event);
      },
      ref: inputRef,
      editable: !disabledTextInput,
      importantForAccessibility: "no",
      accessibilityElementsHidden: true,
      selectTextOnFocus: false,
      pointerEvents: "none"
    }, getTestId(testID, "inputFields"), {
      accessibilityLabel: "Please Enter OTP",
      caretHidden: true
    })), otpFieldsArray.map((_e, id) => {
      var isActive = !disabledTextInput && activeFieldIndex === id;
      return _jsxs(React.Fragment, {
        children: [otpFieldLength === 12 && (id === 4 || id === 8) && _jsx(View, Object.assign({
          style: inputStyles.otpSeparatorWrapper
        }, {
          children: _jsx(View, {
            style: [inputStyles.otpSeparatorSymbol, otpFieldMarginStyle(id)]
          })
        })), _jsx(Typography, Object.assign({
          type: "body-para-" + (checkIsPlatform('web') ? 'md' : 'sm') + "-bold",
          style: [getInputInitialStyles(props, isActive).otpTextStyle, otpFieldMarginStyle(id)],
          accessible: false,
          text: value[id] ? id < maskedLength ? 'X' : value[id] : '-'
        }, getTestId(testID, "textInput_" + id)))]
      }, "otp_field_" + id);
    })]
  }));
};